<app-menus></app-menus>
<div class="page-wrapper">
  <div class="page-content container">
    <router-outlet></router-outlet>
  </div>
</div>

<app-footer></app-footer>
<app-alert [message]="this.errM" *ngIf="this.errM"></app-alert>

<!-- <style>
  .container {
      max-width: 1512px !important;
  }
</style> -->